import { H3 } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { OverviewFallback } from '@/routes/databases/create-database/form/sections/overview/fallback'
import { PaymentMethodFallback } from '@/routes/databases/create-database/form/sections/payment-method/fallback'

export const CreateLoadBalancerFallback = () => {
  return (
    <div className="grid gap-4 grid-cols-1 lg:grid-cols-[2fr_1fr]">
      <Card>
        <CardContent className="p-0">
          <H3 className="mb-6 px-6">Load balancer details</H3>
          <div className="space-y-6 px-6">
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-32 w-full rounded-lg" />
              <Skeleton className="h-32 w-full rounded-lg" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-[40px]" />
              <Skeleton className="h-9 w-full" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-[50px]" />
              <Skeleton className="h-9 w-full" />
            </div>
            <Skeleton className="h-9 w-48" />
          </div>
        </CardContent>
      </Card>
      <div className="flex flex-col gap-4">
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Overview</H3>
              <div className="flex flex-col gap-6">
                <OverviewFallback />
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hidden lg:block">
          <CardContent>
            <div className="flex flex-col gap-4">
              <H3>Payment method</H3>
              <div className="flex flex-col gap-6">
                <PaymentMethodFallback />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
